/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
import React, { Component } from 'react';
import Title from '../../components/Title';
import './styles.scss';
import SurveyQuestion from '../../components/SurveyQuestion';

export class SurveyPage extends Component {
  componentDidMount() {
    if (this.props.userType === null) this.props.getFirstQuestion();
    else this.props.getAnswers();
  }

  handleNext = async () => {
    const anyBlank = Object.keys(this.props.surveyQuestions).some((name) => {
      return this.isBlank(name);
    });
    try {
      if (anyBlank) {
        this.props.showErrors();
      } else if (this.props.userType === null) {
        const userTypeId = this.props.surveyQuestions.on_off_campus.answer.includes('College Housing') ? 1 : 2;
        await this.props.setUserType(userTypeId);
        if (this.props.userType) await this.props.getAnswers();
      } else {
        await this.props.submitSurveyResponses(this.props.surveyQuestions);
        this.props.finishSurvey();
        await this.props.getAnswers();
        if (this.props.done) this.props.history.push('/profile');
      }
    } catch (error) {
      console.log(error);
    }
  }

  isBlank = (name) => {
    const question = this.props.surveyQuestions[name];
    const answer = question?.answer;
    const required = question?.required;
    return (required === 1) && (answer === null || answer === '' || answer?.length === 0 || answer === undefined);
  }

  renderQuestions() {
    return (
      Object.keys(this.props.surveyQuestions).map((name, i) => {
        const q = this.props.surveyQuestions[name];
        return (<SurveyQuestion isBlank={this.isBlank} name={name} title={q.title} type={q.type} options={q.options} required={q.required} key={i} />);
      })
    );
  }

  render() {
    return (
      <div className="surveyPageContainer" onKeyPress={(e) => { if (e.key === 'Enter') this.handleNext(); }}>
        <Title className="surveyTitle"
          userType={this.props.userType}
          name={this.props.name}
          subtitle="We’d love for you to answer some of our questions to help match you with your dream roommate"
        />
        {this.renderQuestions()}
        {this.props.surveyQuestions.length !== 0
        && (
        <div className="surveyErrorContainer">
          {this.props.displayErrors && <p className="surveyErrorButtonText">*Some questions were left blank</p>}
          <button
            className="nextButton"
            type="button"
            onClick={this.handleNext}
          >
            Next
          </button>
        </div>
        )}
      </div>
    );
  }
}

export default SurveyPage;
